<template>
    <div>
      <el-row class="row-bg" style="text-align: left">
        <el-col :span="24" style="line-height: 40px">
          开始时间 :
        </el-col>
        <el-col :span="24">
          <el-date-picker placeholder="开始日期" type="date" :clearable="true" value-format="yyyy-MM-dd" v-model="formData.startDate"></el-date-picker>
        </el-col>
      </el-row>
      <el-row class="row-bg" style="text-align: left">
        <el-col :span="24" style="line-height: 40px">
          结束时间 :
        </el-col>
        <el-col :span="24">
          <el-date-picker placeholder="结束时间" type="date" :clearable="true" value-format="yyyy-MM-dd" v-model="formData.endDate"></el-date-picker>
        </el-col>
      </el-row>
      <el-row class="row-bg" style="text-align: left">
        <el-col :span="24" style="line-height: 40px">
          担当 :
        </el-col>
        <el-col :span="24">
          <el-select default-first-option filterable allow-create v-model="formData.mainId" placeholder="请选择">
            <el-option v-for="item in sgleaders" :key="item[0]" :label="item[1]" :value="item[0]">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="row-bg" style="text-align: left">
        <el-col :span="24" style="line-height: 40px">
          案件接受权限转移至 :
        </el-col>
        <el-col :span="24">
          <el-select default-first-option filterable allow-create v-model="formData.backManId" placeholder="请选择">
            <el-option v-for="item in sgleaders" :key="item[0]" :label="item[1]" :value="item[0]">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-button @click="resetFn">重置</el-button>
        <el-button type="primary" @click="submitFn">确认</el-button>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table  height="300" :data="tableData" style="width: 100%;">
            <el-table-column align="center" prop="mainName" label="担当"></el-table-column>
            <el-table-column align="center" prop="backManName" label="移交担当"></el-table-column>
            <el-table-column align="center" prop="startDate" label="开始日期"></el-table-column>
            <el-table-column align="center" prop="endDate" label="结束日期"></el-table-column>
            <el-table-column align="center" prop="enable" label="状态"></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <div>
                  <el-button type="primary" @click="openFn(scope.row.id)" v-if="!scope.row.enable">开启</el-button>
                  <el-button type="primary" @click="closeFn(scope.row.id)" v-if="scope.row.enable">关闭</el-button>
                  <el-button type="primary" @click="updateFn(scope.row)">修改</el-button>
                </div>
              </template>

            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
			<el-col :span="24" align="center">
				<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNumber"
				 :page-sizes="[20, 30, 40, 50, 100, 200, 5000]" :pager-count="5" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				 :total="total">
				</el-pagination>
			</el-col>
		</el-row>
    </div>
</template>

<script>
import {
  getLeader
} from '@/api/export.js'
import {
  getBackupManList,
  addBackupMan,
  diabledBackupMan,
  enableBackupMan,
  updateBackupMan
} from '@/api/dandangguanli.js'
export default {
  data () {
    return {
      formData: {},
      sgleaders: [],
      tableData: [],
      pageSize: 20,
      total: 0,
      pageNumber: 0
    }
  },
  created () {
    this.getDefaultData()
    this.getData()
  },
  methods: {
    updateFn(val) {
      this.formData = val
    },
    openFn (val) {
      enableBackupMan({id: val}).then(res => {
        this.getData()
      })
    },
    closeFn (val) {
      diabledBackupMan({id: val}).then(res => {
        this.getData()
      })
    },
    resetFn () {
      this.formData = {}
    },
    submitFn () {
      console.log(this.formData)
      const mainList = this.sgleaders.filter(item => item[0] === this.formData.mainId)
      let mainName = ''
      let backManName = ''
      if (mainList && mainList.length > 0) {
        mainName = mainList[0][1]
      }
      const backManNameList = this.sgleaders.filter(item => item[0] === this.formData.backManId)
      if (backManNameList && backManNameList.length > 0) {
        backManName = backManNameList[0][1]
      }

      this.formData = { ...this.formData, backId: this.formData.backManId, startDateStr: this.formData.startDate, endDateStr: this.formData.endDate }
      if(this.formData.id){
        updateBackupMan(this.formData).then(res => {
          this.formData = {}
          this.getData()
        })
      }else{
        addBackupMan(this.formData).then(res => {
          console.log(res)
          this.formData = {}
          this.getData()
        })
      }
      
    },
    // 当页码改变时
    handleCurrentChange (val) {
      let pageNumber = val - 1
      this.pageNumber = val
      getBackupManList(this.pageSize, pageNumber, this.formData).then(res => {
        this.tableData = res.data.content
      })
    },
    // 当页面条数改变时
    handleSizeChange (val) {
      this.pageSize = val
      let that = this
      getBackupManList(this.pageSize, 0, this.formData).then(res => {
        that.tableData = res.data.content
      })
    },
    getData () {
      getBackupManList(this.pageSize, this.pageNumber - 1).then(res => {
        console.log(res)
        this.tableData = res.data.content
        this.total = res.data.totalElements
        this.pageNumber = 1
      })
    },
    getDefaultData () {
      // 获取担当list
      getLeader().then(res => {
        let res1 = res.data.data
        let arr = []
        for (let i = 0; i < res1.length; i++) {
          arr.push(res1[i][1])
        }
        this.sgleaders = res1
      })
    }
  }
}
</script>
